import script from "./DatasetVersions.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetVersions.vue?vue&type=script&setup=true&lang=js"

import "./DatasetVersions.vue?vue&type=style&index=0&id=0c4aa152&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4aa152"]])

export default __exports__